import * as React from 'react';
import { ProductLessons as ProductLessonsModel } from '../../../types/generated';
import { Lesson } from '../../../types/generated';

interface ProductLessonProps {
  productLessons: ProductLessonsModel;
}

export default function ProductLessons({
  productLessons
}: ProductLessonProps): React.ReactElement {
  return (
    <aside className="product-lessons">
      <div className="product-lessons__inner">
        <header className="product-lessons__header">
          <h3 className="product-lessons__title">
            Lessons and Lesson Resources
          </h3>
        </header>
        <div className="product-lessons__lessons">
          {productLessons.lessons?.map((lesson: Lesson) => (
            <article key={lesson.id} className="product-lesson">
              <a
                href={lesson.lessonUrl || ''}
                target="_blank"
                rel="noreferrer"
                className="product-lesson__link"
              >
                <div className="product-lesson__image-wrapper">
                  <img
                    alt=""
                    src={lesson.imageUrl ? `${lesson.imageUrl}?width=100` : ''}
                    className="product-lesson__image"
                  />
                </div>
                <div
                  className="product-lesson__title"
                  title={lesson.name || ''}
                >
                  {lesson.name}{' '}
                </div>
                <div className="product-lesson__key-stages">
                  <LessonKeyStages keyStages={lesson.keyStages} />
                </div>
              </a>
            </article>
          ))}
          <AdditionalLessons productLessons={productLessons} />
        </div>
      </div>
    </aside>
  );
}

interface AdditionalLessonsProps {
  productLessons: ProductLessonsModel;
}

function AdditionalLessons({ productLessons }: AdditionalLessonsProps) {
  const searchUrl = productLessons.searchUrl;
  return (
    <div className="product-lessons-additional">
      {productLessons.additionalLessonCount > 0 && (
        <a
          href={searchUrl || ''}
          target="_blank"
          rel="noreferrer"
          className="product-lessons-additional__link"
        >
          More...
        </a>
      )}
      <div className="product-lessons-additional__description">
        Links will open in EuHu
      </div>
    </div>
  );
}

interface LessonKeyStageProps {
  keyStages: string[];
}

function LessonKeyStages({ keyStages }: LessonKeyStageProps) {
  if (!keyStages || keyStages.length === 0) {
    return null;
  }

  const keyStageElements = keyStages.map((keyStage) => {
    if (keyStage !== 'undefined' && keyStage === 'KEY STAGE 1') {
      return (
        <div className="product-lesson-key-stage product-lesson-key-stage--ks1"></div>
      );
    }

    if (keyStage !== 'undefined' && keyStage === 'KEY STAGE 2') {
      return (
        <div className="product-lesson-key-stage product-lesson-key-stage--ks2"></div>
      );
    }

    if (keyStage !== 'undefined' && keyStage === 'EYFS') {
      return (
        <div className="product-lesson-key-stage product-lesson-key-stage--eyfs"></div>
      );
    }

    return <></>;
  });

  return (
    <>
      {keyStageElements.map((keyStage) => (
        <>{keyStage}</>
      ))}
    </>
  );
}
